/**
 * This function returns the sumOfShapes function
 * This function gives sumOfShapes access to the peak list and the associated data
 * @param internalPeaks
 */
export function getSumOfShapes(internalPeaks) {
    return function sumOfShapes(parameters) {
        for (const peak of internalPeaks) {
            for (let i = 2; i < parameters.length; i++) {
                const shapeFctKey = peak.parameters[i];
                peak.shapeFct[shapeFctKey] = parameters[peak.fromIndex + i];
            }
        }
        return (x) => {
            let totalY = 0;
            for (const peak of internalPeaks) {
                const peakX = parameters[peak.fromIndex];
                const y = parameters[peak.fromIndex + 1];
                totalY += y * peak.shapeFct.fct(x - peakX);
            }
            return totalY;
        };
    };
}
//# sourceMappingURL=getSumOfShapes.js.map